//drawer mobile para reemplazar el drawer que manejamos en produccion
//este componente esta hecho para poder mostrarlo dentro del iframe
//en la vista preview de un evento creado

import React, { useState } from "react";
import { Box, Button, ButtonGroup, IconButton, Tooltip } from "@mui/material";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { CloseOutlined, ExpandLess, ExpandMore, ShoppingCartOutlined, InfoOutlined } from "@mui/icons-material";

export const DrawerPreviewMobile = ({
  open,
  onClose,
  tarifas = [],
  cantidad,
  setCantidad,
  tarifasSeleccionadas,
  setTarifasSeleccionadas,
}) => {
  const [showResume, setShowResume] = useState(false);

  const incremento = (idtarifa) => {
    const nuevoCantidad = {
      ...cantidad,
      [idtarifa]: (cantidad[idtarifa] || 0) + 1,
    };
    setCantidad(nuevoCantidad);
    actualizarSeleccionadas(nuevoCantidad);
  };

  const decremento = (idtarifa) => {
    const nuevoCantidad = {
      ...cantidad,
      [idtarifa]: Math.max(0, (cantidad[idtarifa] || 0) - 1),
    };
    setCantidad(nuevoCantidad);
    actualizarSeleccionadas(nuevoCantidad);
  };

  const actualizarSeleccionadas = (cantidades) => {
    const nuevas = tarifas
      .filter((t) => (cantidades[t.id] || 0) > 0)
      .map((t) => ({
        ...t,
        cantidad: cantidades[t.id] || 0,
        precio: t.precio || 0,
      }));
    setTarifasSeleccionadas(nuevas);
  };

  const subtotal = tarifasSeleccionadas.reduce(
    (acc, t) => acc + (t.cantidad || 0) * (t.precio || 0),
    0
  );
  const comision = tarifasSeleccionadas.reduce(
    (acc, t) =>
      acc +
      (t.cantidad || 0) *
      ((t.precio || 0) * ((t.tipo_comision?.porcentaje ?? 0) / 100)),
    0
  );
  const total = subtotal + comision;

  if (!open) return null;

  return (
    <>
      <Box>
        <Box
          onClick={onClose}
          sx={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0,0,0,0.35)",
            zIndex: 1199,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: "#f8f8ff",
            borderRadius: "10px 10px 0 0",
            boxShadow: "0 -2px 8px rgba(0,0,0,0.15)",
            zIndex: 1200,
            minHeight: "30vh",
            maxHeight: "90vh",
            overflowY: "auto",
            p: 0,
            transition: "transform 0.3s",
          }}
        >
          <IconButton
            sx={{ position: "absolute", right: 8, top: 8, zIndex: 2 }}
            onClick={onClose}
            aria-label="close"
            size="small"
          >
            <CloseOutlined style={{ color: "#221a60" }} />
          </IconButton>
          <Box className="p-4 d-flex flex-column justify-content-between gap-2" sx={{ pt: 6 }}>
            {!showResume ? (
              <>
                <div className="text-center mb-2">
                  <p className="m-0 fs-3 fw-bold" style={{ color: "#221a60" }}>
                    Tarifas
                  </p>
                </div>
                {tarifas.length === 0 ? (
                  <div className="d-flex align-items-center flex-column">
                    <div
                      className="contenedor-badge px-4 py-2"
                      style={{
                        background: "#dadaff",
                        color: "#3d2eab",
                        fontSize: "24px",
                      }}
                    >
                      ¡Próxima apertura!
                    </div>
                  </div>
                ) : (
                  tarifas.map((tarifa) => (
                    <div key={tarifa.id} className="position-relative my-3">
                      <div className="barra-tarifas" />
                      <div className="ps-4 d-flex flex-column gap-1">
                        <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                          <div className="d-flex flex-column gap-1">
                            <p className="fw-medium m-0">{tarifa.concepto}</p>
                          </div>
                          <ButtonGroup>
                            <Button
                              className="fw-bold"
                              disabled={cantidad[tarifa.id] === 0}
                              onClick={() => decremento(tarifa.id)}
                              sx={{
                                width: "40px",
                                color: "#221a60",
                                borderColor: "#221a60",
                              }}
                              aria-label="restar"
                            >
                              -
                            </Button>
                            <Button
                              className="fw-bold"
                              disabled
                              style={{
                                width: "40px",
                                color: "#221a60",
                                borderColor: "#221a60",
                                cursor: "default",
                              }}
                              aria-label={`Cantidad ${cantidad[tarifa.id] || 0}`}
                            >
                              {cantidad[tarifa.id] || 0}
                            </Button>
                            <Button
                              className="fw-bold"
                              onClick={() => incremento(tarifa.id)}
                              sx={{
                                width: "40px",
                                color: "#221a60",
                                borderColor: "#221a60",
                              }}
                              aria-label="sumar"
                            >
                              +
                            </Button>
                          </ButtonGroup>
                        </div>
                        <div className="d-flex flex-wrap">
                          <p className="fw-medium m-0 d-inline-block">
                            ${" "}
                            {(tarifa.precio || 0).toLocaleString("es-ES", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              useGrouping: true,
                            })}
                          </p>
                          <small className="text-secondary">
                            {" + $ "}
                            {(
                              (tarifa.precio || 0) *
                              ((tarifa.tipo_comision?.porcentaje ?? 0) / 100)
                            ).toLocaleString("es-ES", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                              useGrouping: true,
                            })}{" "}
                            costo del servicio
                          </small>
                        </div>
                      </div>
                    </div>
                  ))
                )}
                <Box className="d-flex flex-column">
                  <p
                    className="mb-2 fs-3 fw-medium align-self-end"
                    onClick={() => setShowResume(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <ExpandLess /> ${total.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
                  </p>
                  <small className="mb-2 align-self-end">
                    {format(
                      new Date(),
                      "E. d 'de' MMM. 'de' u HH:mm 'hs'",
                      {
                        locale: es,
                      }
                    )}
                  </small>
                </Box>
                <Button
                  className="boton-submit w-100"
                  fullWidth
                  /* disabled */
                  sx={{ mt: 2 }}
                  startIcon={<ShoppingCartOutlined />}
                >
                  Finalizar compra
                </Button>
              </>
            ) : (
              <>
                <p className="mb-1 fw-bold fs-4">Resumen de tu compra</p>
                {tarifasSeleccionadas.length > 0 ? (
                  tarifasSeleccionadas.map((tarifa) => (
                    <div key={tarifa.id} className="my-3">
                      <div className="d-flex justify-content-between flex-wrap py-2">
                        <p className="fw-medium mb-0">
                          {`${tarifa.cantidad || 0} x ${tarifa.concepto || ''}`}
                        </p>
                        <p className="fw-medium mb-0">
                          $ {((tarifa.cantidad || 0) * (tarifa.precio || 0)).toLocaleString("es-ES", { minimumFractionDigits: 2 })}
                        </p>
                      </div>
                      <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} />
                    </div>
                  ))
                ) : (
                  <p className="text-center">No hay tarifas seleccionadas.</p>
                )}
                {tarifasSeleccionadas.length > 0 && (
                  <>
                    <div className="d-flex justify-content-between flex-wrap py-2">
                      <p className="fw-medium mb-0 fs-5">Subtotal</p>
                      <p className="fw-medium mb-0 fs-5">
                        $ {subtotal.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
                      </p>
                    </div>
                    <div className="d-flex justify-content-between flex-wrap py-2">
                      <div className="d-flex align-items-center gap-1">
                        <p className="fw-medium mb-0 fs-5">Costo</p>
                        <Tooltip
                          title="El costo de servicio de PassGo no es reembolsable"
                          placement="right"
                          arrow
                        >
                          <InfoOutlined fontSize="small" />
                        </Tooltip>
                      </div>
                      <p className="fw-medium mb-0 fs-5">
                        $ {comision.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
                      </p>
                    </div>
                    <hr className="mx-3 border-2" style={{ color: "#D9D9D9" }} />
                    <div className="d-flex justify-content-between flex-wrap py-2">
                      <p className="fw-medium mb-0 fs-3">Total</p>
                      <span className="text-end">
                        <p className="fw-medium mb-0 fs-3">
                          $ {total.toLocaleString("es-ES", { minimumFractionDigits: 2 })}
                        </p>
                        <small>El precio incluye impuestos</small>
                      </span>
                    </div>
                  </>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  sx={{ mt: 2 }}
                  onClick={() => setShowResume(false)}
                  startIcon={<ExpandMore />}
                >
                  Volver
                </Button>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};